<template>
<div>
<v-toolbar dark class="primary">
    <v-btn @click.native="$router.push('/home')" icon>
        <v-icon>chevron_left</v-icon>
    </v-btn>        
    <v-toolbar-title>{{pageTitle}} 
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn icon>
        <v-icon>search</v-icon>
    </v-btn>
    <v-btn icon>
        <v-icon>more_vert</v-icon>
    </v-btn>
</v-toolbar>  

<div style="display:flex;max-width:800px;">
         <v-list two-line subheader>

          <v-list-item
            v-for="dash in dashes"
            :key="dash.name"
           
            @click="selectDash(dash)"
          >
            <v-list-item-avatar>
              <v-icon>insert_chart</v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>{{ dash.name }}</v-list-item-title>
              <v-list-item-subtitle>{{ dash.section }} - {{dash.field}}</v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
              <v-btn icon ripple>
                <v-icon color="grey lighten-1">info</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
         </v-list>
        
    <!-- </div> -->

    <!-- ***************** Right Column ******************* -->
    <!-- <div class="taco-column pa-4"> -->
        <div style="flex-grow:1;">

            <div v-if="!editMode" transition="slide-x-transition">
                <v-btn color="grey lighten-2" style="float:right;z-index:1000" icon @click="editMode = true"><v-icon color="grey">edit</v-icon></v-btn>
                <Dashboard :dash="dash"/>
            </div>
            <div v-else transition="slide-x-transition">
            <v-text-field v-model="dash.name" label="Name"></v-text-field>
                <v-text-field v-model="dash.section" label="Section"></v-text-field>
                <v-text-field v-model="dash.field" label="Field"></v-text-field>
                <v-btn color="primary" @click="saveDash(dash)">Save</v-btn>
                <v-btn @click="editMode=false">Cancel</v-btn>
            </div>
        </div>
</div>
 
    <!-- </div>  -->
    <!-- End right column -->
<!-- </div> -->
<!-- </div>   -->

<!-- </div> -->
</div>
</template>

<script>
import Firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import NumberHelpers from '../helpers/NumberHelpers'
import DataHelpers from '../helpers/DataHelpers'
import FirebaseHelpers from '../helpers/FirebaseHelpers'
import Dashboard from '../ui-elements/Dashboard'
export default {

name: 'Dashboards',

data() {
    return {
        editMode: false,
        dashes: [],
        dash: {
            name: null,
            section: null,
            field: null
        }
    }
},

props: {
    dashKey: String
},

components: {
    Dashboard,
},

computed:{
    dashRef() {
        return DataHelpers.getTenantRef().child('dashboards')
    },
    pageTitle() {
        return "Dashboards" + (this.dash && this.dash.name ? ' - ' + this.dash.name : '')
    }

},
methods: {
    saveDash(dash) { 
        FirebaseHelpers.saveToFirebase(dash, this.dashRef)
    },
    selectDash(dash) {
        this.$router.push('/dashboards/' + dash.key)
    },
    loadDash() {
        let dash = this.dashes.find(o => o.key == this.dashKey  )
        
        if(dash)
            this.dash = dash
    }

},

watch: {
    dashKey (newVal, oldVal) {
        this.loadDash(newVal)
    }
},
created() {
    this.dashRef.on('value', snap => {
        this.dashes = FirebaseHelpers.snapshotToArray(snap)
        this.loadDash()
    })
}
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// Dashboards.vue?4572e621